import firebase from "firebase"

export function db() { return firebase.database() }

export function storage() { return firebase.storage() }
